import invariant from 'invariant';
import { conformsTo, isFunction, isObject } from 'lodash';

/**
 * Validate the shape of redux store
 */
export function checkStore(store) {
  const shape = {
    dispatch: isFunction,
    subscribe: isFunction,
    getState: isFunction,
    replaceReducer: isFunction,
    runSaga: isFunction,
    injectedSagas: isObject
  };

  invariant(conformsTo(store, shape), '(app/utils...) injectors: Expected a valid redux store');
}
